import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface TaboolaScriptProps {
  accountID?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function ta(ctx: TaboolaScriptProps) {
  /*eslint-disable */
  // prettier-ignore
  if (ctx.accountID) {
    window._tfa = window._tfa || [];
    window._tfa.push({notify: 'event', name: 'page_view'});
    // @ts-ignore
    !function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = !!1;t.src = a;t.id=x;f&&f.parentNode&&f.parentNode.insertBefore(t, f);
      }
    }(document.createElement('script'),
    document.getElementsByTagName('script')[0],
    '//cdn.taboola.com/libtrc/unip/'+ctx.accountID+'/tfa.js',
    'tb_tfa_script');
    /*eslint-enable */
  }
}

export const TaboolaScript = (props: TaboolaScriptProps): JSX.Element => {
  const accountID = props.accountID || process.env.NEXT_PUBLIC_TABOOLA_ACCOUNT_ID;
  return (
    <Head>
      {preConnect('//cdn.taboola.com', accountID || false)}
      {makeScript(ta, {
        accountID,
      })}
    </Head>
  );
};

export default TaboolaScript;
